import React from "react";
import ReactDOM from "react-dom/client";

import { Provider } from "react-redux";
import { configureStore } from "./redux/store";

import { MainApp } from "./MainApp";

const store = configureStore();
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <MainApp />
    </React.StrictMode>
  </Provider>
);
